export const apiName: string = 'manutencoes-programadas';
export const manutencoesProgramadaRoute: string = 'manutencoes-programadas';
export const manutencoesProgramadaStorage: string = 'manutencaoProgramada';
export const manutencoesProgramadaModuleName: any = {plural: 'Alarmes de Manutenção', single: 'Alarme de Manutenção'};

export const tiposVencimento: any[] = [
    {Key: 3, Value: 'Vencidos'},
    {Key: 2, Value: 'A vencer'},
];

//status api
//1 verde
//2 amarelo
//3 vermelho

export const selectedList: any[] = [
    {Key: 1, Value: 'Criar manutenção'},
    {Key: 2, Value: 'Excluir'},
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencao-programada/shared/data.service.ts
 **/